import { format, parse, isValid, isBefore, isAfter, add } from 'date-fns';
import { es } from 'date-fns/locale';
import { toZonedTime, fromZonedTime } from 'date-fns-tz';

export const formatDate = (date, formatString = 'dd-MM-yyyy') => {
  if (!date) return '';
  const dateObj = date instanceof Date ? date : new Date(date);
  if (!isValid(dateObj)) return '';
  return format(dateObj, formatString, { locale: es });
};

export const parseDate = (dateString, formatString = 'dd/MM/yyyy') => {
  if (!dateString) return null;
  try {
    const parsed = parse(dateString, formatString, new Date(), { locale: es });
    return isValid(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const isDateBefore = (date1, date2) => {
  if (!date1 || !date2) return false;
  const d1 = date1 instanceof Date ? date1 : new Date(date1);
  const d2 = date2 instanceof Date ? date2 : new Date(date2);
  return isBefore(d1, d2);
};

export const isDateAfter = (date1, date2) => {
  if (!date1 || !date2) return false;
  const d1 = date1 instanceof Date ? date1 : new Date(date1);
  const d2 = date2 instanceof Date ? date2 : new Date(date2);
  return isAfter(d1, d2);
};

export const addMonths = (date, months) => {
  if (!date) return null;
  const dateObj = date instanceof Date ? date : new Date(date);
  return add(dateObj, { months });
};

export const addDays = (date, days) => {
  if (!date) return null;
  const dateObj = date instanceof Date ? date : new Date(date);
  return add(dateObj, { days });
};

export const toUTC = (date) => {
  if (!date) return null;
  const dateObj = date instanceof Date ? date : new Date(date);
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  return fromZonedTime(dateObj, timeZone);
};

export const fromUTC = (date) => {
  if (!date) return null;
  const dateObj = date instanceof Date ? date : new Date(date);
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  return toZonedTime(dateObj, timeZone);
};

export const formatToLocaleDate = (date) => {
  if (!date) return '';
  const dateObj = date instanceof Date ? date : new Date(date);
  if (!isValid(dateObj)) return '';
  return dateObj.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const getMonthName = (date) => {
  if (!date) return '';
  const dateObj = date instanceof Date ? date : new Date(date);
  if (!isValid(dateObj)) return '';
  return format(dateObj, 'MMMM', { locale: es });
};

export const parseDateString = (dateString, formatString = 'dd/MM/yyyy') => {
  if (!dateString) return null;
  try {
    const parsed = parse(dateString, formatString, new Date(), { locale: es });
    return isValid(parsed) ? parsed : null;
  } catch {
    return null;
  }
};
